import axios from '../axios';
const END_POINT = '/service-groups';


const addServiceGroups = (banks) => axios.post(`${END_POINT}`, banks);
const getServiceGroups = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getServiceGroup = (serviceGroupsId) => axios.get(`${END_POINT}/${serviceGroupsId}`);
const updateServiceGroups = (serviceGroupsId, payload) => axios.patch(`${END_POINT}/${serviceGroupsId}`, payload);
const searchServiceGroup = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteServiceGroup = (serviceGroupsId) => axios.delete(`${END_POINT}/${serviceGroupsId}`);

export {
    addServiceGroups,
    getServiceGroups,
    getServiceGroup,
    updateServiceGroups,
    searchServiceGroup,
    deleteServiceGroup
}